export const HandshakeIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Handshake Icon</title>
      <path
        d="M12.5 13.9517L11.25 12.7017"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4166 15.5897L9.58325 14.7849"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2499 7.28489L8.43262 9.47606C7.89977 9.89056 7.14165 9.84331 6.66429 9.36598C6.18887 8.89056 6.13988 8.13623 6.54983 7.60329L9.33404 3.98381C9.73838 3.45814 10.416 3.22224 11.0593 3.38309L14.9999 4.36824H19.1665V11.8682H17.4999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4166 8.11833L13.7487 10.8951C14.5903 11.5965 14.5379 12.9052 13.6428 13.5371L9.38667 16.5414C8.76633 16.9792 7.92854 16.9426 7.34894 16.4521L2.91659 12.7017H0.833252V5.20166H4.16658"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
